// extracted by mini-css-extract-plugin
export var button = "styles-module--button--58289";
export var content = "styles-module--content--fa355";
export var logo = "styles-module--logo--ed743";
export var section = "styles-module--section--f3577";
export var textContainer = "styles-module--textContainer--4acd6";
export var title = "styles-module--title--7ac49";